import React from 'react';
import DeleteIcon from '../Resources/Icons/DeleteIcon';
import ResizeIcon from '../Resources/Icons/ResizeIcon';
import LoopIcon from '../Resources/Icons/LoopIcon';
import { DefaultDesigner } from '@configuratorware/configurator-frontendgui/App/Modules/Designer/DesignerUI';
import Typography from '@material-ui/core/Typography';

const toolboxButtonStyle = {
  width: 40,
  height: 40,
  padding: 0,
  border: '1px solid rgba(0,0,0,0.23)',
  boxSizing: 'border-box',
  borderRadius: 3,
  background: 'white',
  outline: 0,
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  color: '#282828',
};
const transformTopRight = { transform: 'translate(0%, -100%)' };
const transformBottomRight = { transform: 'translate(0%, 0%)' };
const transformBottomLeft = { transform: 'translate(-100%, 0%)' };

const renderInlineToolButton = ({
  positionName,
  onScalingChange,
  onRotationChange,
  onDeleteClick,
  selectedObject,
  components: { InlineToolboxButton },
}) => {
  if (!selectedObject) {
    return null;
  }
  switch (positionName) {
    case 'topRight':
      return (
        !selectedObject.locked && (
          <InlineToolboxButton
            style={{ ...toolboxButtonStyle, ...transformTopRight }}
            onTouchStart={onRotationChange}
            onMouseDown={onRotationChange}
          >
            <LoopIcon style={{ alignSelf: 'center' }} />
          </InlineToolboxButton>
        )
      );
    case 'bottomRight':
      return (
        !selectedObject.locked && (
          <InlineToolboxButton
            style={{ ...toolboxButtonStyle, ...transformBottomRight }}
            onTouchStart={onScalingChange}
            onMouseDown={onScalingChange}
          >
            <ResizeIcon style={{ alignSelf: 'center' }} />
          </InlineToolboxButton>
        )
      );
    case 'bottomLeft':
      return (
        <InlineToolboxButton
          style={{ ...toolboxButtonStyle, ...transformBottomLeft }}
          onClick={onDeleteClick}
        >
          <DeleteIcon style={{ alignSelf: 'center' }} />
        </InlineToolboxButton>
      );
    case 'topLeft':
      // not used
      return null;
  }
};

const renderAngleLabel = (angleLabel) => <Typography>{angleLabel}</Typography>;

const renderInlineToolbox = ({ components: { InlineToolbox } }) => (
  <InlineToolbox renderToolboxButton={renderInlineToolButton} renderAngleLabel={renderAngleLabel} />
);

// eslint-disable-next-line react/prop-types
export const CustomDesigner = ({ visualizationOverlayMode, ...props }) => {
  return (
    <DefaultDesigner
      visualizationOverlayMode={visualizationOverlayMode}
      renderInlineToolbox={renderInlineToolbox}
      renderStandardToolbox={() => null}
      {...props}
    />
  );
};
